import { ImageModel, images } from "./data";
import { initializeGallery } from "./gallery";
import { initializeLocation } from "./router";
import { strictQuerySelector } from "./utilities";
import { setFullImage, unsetFullImage } from "./full-image";

import "./index.css";

const workLinkEl = strictQuerySelector<HTMLAnchorElement>(document, '#work-link');
const cvLinkEl = strictQuerySelector<HTMLAnchorElement>(document, '#cv-link');

function setBodyClass (className?: string) {
  document.body.className = '';

  if (className) {
    document.body.classList.add(className);
  }
}

function setCurrentLink (location: string) {
  if (location === 'curriculum-vitae') {

    workLinkEl.classList.remove('current');
    cvLinkEl.classList.add('current');

  } else {

    cvLinkEl.classList.remove('current');
    workLinkEl.classList.add('current');

  }
}

function initialize () {
  processData();
  initializeGallery(images);
  initializeLocation(); 
}

function processData () {
  const imageDataElement = strictQuerySelector(document, '#image-data');
  const dataText = imageDataElement.textContent || ''
  const imageData: ImageModel[] = window.JSON.parse(dataText);

  imageData.forEach(function (image, index) {
    if (!image.hide) {
      processImage(image, index);
      images.push(image);
    }
  });
}

function processImage (image: ImageModel, index: number) {
  image._id = index + 1;
  image.columnSpan = image.columnSpan || 1;
  image.detail = false;
  image.details = image.details || [];
  image.hide = image.hide || false;

  if (Array.isArray(image.details)) {
    image.details.forEach(function (detail) {
      detail.detail = true;
    });
  }
}

window.addEventListener('locationchange', function (e) {
  if (!(e instanceof CustomEvent)) {
    return;
  }

  const newLocation = e.detail.newLocation;
  let newImage;
  let bodyClass;

  for (let i = 0; i < images.length; i++) {
    if (images[i].slug === newLocation) {
      newImage = images[i];
      break;
    }
  }

  if (newImage) { // Individual image view
    
    bodyClass = 'full-image';

  } else if (newLocation === 'curriculum-vitae') { 

    bodyClass = newLocation;
  }

  setBodyClass(bodyClass);

  newImage ? setFullImage(newImage) : unsetFullImage();
  setCurrentLink(newLocation);
});

initialize();